import { useFormContext ,Controller} from "react-hook-form";
import { TextField, Button, Box, Typography, FormControl, InputLabel, MenuItem, Select, Grid2 ,Checkbox,FormControlLabel } from "@mui/material";
import { prefixer } from 'stylis';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useEffect } from 'react';









// const theme = createTheme((outerTheme) => ({
  
//   palette: {
//     mode: outerTheme.palette.mode,
//   },
// }));

// const cacheRtl = createCache({
//   key: 'muirtl',
//   stylisPlugins: [prefixer, rtlPlugin],
// });

const theme = createTheme({
  direction: 'rtl',
  typography: {
    fontSize: 20,
    fontFamily: 'Tajawal, Arial, sans-serif',
    fontWeight: 'bold',
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
  },
});



const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});


const WebForm = ({ onNext ,isSocial }) => {
  const { register, handleSubmit, formState: { errors }, watch , control , setValue } = useFormContext();
  // const [responseMsg, setResponseMsg] = useState("");
  // const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const socialStatus = watch("socialStatus");
  const sex = watch("sex");
  const profession = watch("profession");
  const damage = watch("damage");
  const isParentAlive = watch("isParentAlive");
  const isPreviousAddressSame = watch("isPreviousAddressSame");

  const onSubmit = async (data) => {
    try {
     onNext();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (socialStatus !== "متزوج/متزوجة" || sex === "انثى") {
      setValue("numberOfWives", "0"); // Reset the field to 0
    }
  }, [socialStatus, setValue, sex,damage]);

  return (
   
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
    <Box dir="rtl" 
    style={{ fontSize: 20 }}
      component="form" 
     onSubmit={handleSubmit(onSubmit)}
      
      sx={{ 
        maxWidth: 1000, 
        mx: "auto", 
        mt: 5, 
        p: 3, 
        boxShadow: 3, 
        borderRadius: 2, 
        textAlign: "right", // Align text to right
        direction: "rtl" // Ensure proper RTL direction
      }}
    >
      {/* <Typography sx={{ textAlign: "center"}} variant="h5" gutterBottom>
       معلومات الشهيد    </Typography> */}
     

      {/* {responseMsg && <Alert severity="info">{responseMsg}</Alert>} */}

  {/* <FormControl fullWidth margin="normal" error={!!errors.damage}>
        <InputLabel>اختر نوع الضرر</InputLabel>
        <Controller
          name="damage"
          control={control}
          rules={{ required: "الرجاء اختيار نوع الضرر" }}
          render={({ field }) => (
            <Select
              {...field}
              label="اختر نوع الضرر"
              sx={{ textAlign: "right", direction: "rtl" , fontSize: 20 , fontWeight: "bold" }}
            >
              <MenuItem value={1}>شهيد</MenuItem>
              <MenuItem value={2}>مصاب</MenuItem>
            </Select>
          )}
        />
        {errors.damage && <Typography color="error">{errors.damage.message}</Typography>}
      </FormControl> */}
      <FormControl fullWidth margin="normal" error={!!errors.district}>
        <InputLabel>اختر المديرية</InputLabel>
        <Controller
          name="district"
          control={control}
          rules={{ required: "الرجاء اختيار المديرية" }}
          render={({ field }) => (
            <Select
              {...field}
              label="اختر المديرية"
              sx={{ textAlign: "right", direction: "rtl" , fontSize: 20 , fontWeight: "bold" }}
            >
              <MenuItem value={1}>مديرية شهداء الكرخ</MenuItem>
<MenuItem value={2}>مديرية شهداء الصدر</MenuItem>
<MenuItem value={3}>مديرية شهداء الرصافة</MenuItem>
<MenuItem value={4}>مديرية شهداء كربلاء المقدسة</MenuItem>
<MenuItem value={5}>مديرية شهداء النجف الاشرف</MenuItem>
<MenuItem value={6}>مديرية شهداء بابل</MenuItem>
<MenuItem value={7}>مديرية شهداء واسط</MenuItem>
<MenuItem value={8}>مديرية شهداء الديوانية</MenuItem>
<MenuItem value={9}>مديرية شهداء المثنى</MenuItem>
<MenuItem value={10}>مديرية شهداء البصرة</MenuItem>
<MenuItem value={11}>مديرية شهداء ذي قار</MenuItem>
<MenuItem value={12}>مديرية شهداء ميسان</MenuItem>
<MenuItem value={13}>مديرية شهداء ديالى</MenuItem>
<MenuItem value={14}>مديرية شهداء نينوى</MenuItem>
<MenuItem value={15}>مديرية شهداء الانبار</MenuItem>
<MenuItem value={16}>مديرية شهداء صلاح الدين</MenuItem>
<MenuItem value={17}>مديرية شهداء كركوك</MenuItem>
<MenuItem value={18}>مديرية شهداء شمال البصرة</MenuItem>
            </Select>
          )}
        />
        {errors.district && <Typography color="error">{errors.district.message}</Typography>}
      </FormControl>

      <TextField
  label={damage === 1 ? "ألاسم الاول للشهيد" : "ألاسم الاول للجريح"}
  fullWidth
  margin="normal"
  {...register("firstName", {
    required: damage === 1 ? "اسم الشهيد مطلوب" : "اسم الجريح مطلوب",
    pattern: {
      value: /^[\u0600-\u06FF]+$/, // Arabic letters only
      message: "يُسمح فقط بالحروف العربية بدون مسافات أو رموز"
    }
  })}
  error={!!errors.firstName} // Corrected the error reference to firstName
  helperText={errors.firstName?.message} // Corrected the error reference to firstName
  sx={{
    textAlign: "right", // Align text to the right
    direction: "rtl"  ,// Set the direction to right-to-left
    fontSize: 20
  }}
  // InputLabelProps={{
  //   shrink: true,
  //   style: { fontSize: 20 , fontWeight: "bold" }
  // }}
  InputProps={{
    style: { fontSize: 20 , direction: "rtl" }
  }}
/>
      <TextField
        label={damage === 1 ? "اسم اب الشهيد" : "اسم اب الجريح"} 
        fullWidth 
        margin="normal"
        {...register("secondName", { 
          required: damage === 1 ? "اسم اب الشهيد مطلوب" : "اسم اب الجريح مطلوب",
          pattern: { 
            value: /^[\u0600-\u06FF]+$/, // Arabic letters only
            message: "يُسمح فقط بالحروف العربية بدون مسافات أو رموز" 
          } 
        })} 
        error={!!errors.secondName} 
        helperText={errors.secondName?.message} 
        sx={{ textAlign: "right", direction: "rtl" }} 
      
        InputProps={{
          style: { fontSize: 20 , direction: "rtl" }
        }}
      />




<TextField 
  label={damage === 1 ? "اسم جد الشهيد" : "اسم جد الجريح"}
  fullWidth 
  margin="normal"
  {...register("thirdName", { 
    required: damage === 1 ? "اسم جد الشهيد مطلوب" : "اسم جد الجريح مطلوب",
    pattern: { 
      value: /^[\u0600-\u06FF]+$/, // Arabic letters only
      message: "يُسمح فقط بالحروف العربية بدون مسافات أو رموز" 
    } 
  })} 
  error={!!errors.thirdName} 
  helperText={errors.thirdName?.message} 
  sx={{ textAlign: "right", direction: "rtl" }} 
  
  InputProps={{
    style: { fontSize: 20 , direction: "rtl" }
  }}
/>
<TextField 
  label={damage === 1 ? "الاسم اب جد الشهيد" : "الاسم اب جد الجريح"} 
  fullWidth 
  margin="normal"
  {...register("fourthName", { 
    required: damage === 1 ? "الاسم اب جد الشهيد مطلوب" : "الاسم اب جد الجريح مطلوب",
    pattern: { 
      value: /^[\u0600-\u06FF]+$/, // Arabic letters only
      message: "يُسمح فقط بالحروف العربية بدون مسافات أو رموز" 
    } 
  })} 
  error={!!errors.fourthName} 
  helperText={errors.fourthName?.message} 
  sx={{ textAlign: "right", direction: "rtl" }} 
 
  InputProps={{
    style: { fontSize: 20 , direction: "rtl" }
  }}
/>
<TextField 
  label={damage === 1 ? "لقب الشهيد" : "لقب الجريح"} 
  fullWidth 
  margin="normal"
  {...register("surname", { 
    required: damage === 1 ? "لقب الشهيد مطلوب" : "لقب الجريح مطلوب",
    pattern: { 
      value: /^[\u0600-\u06FF]+$/, // Arabic letters only
      message: "يُسمح فقط بالحروف العربية بدون مسافات أو رموز" 
    } 
  })} 
  error={!!errors.surname} 
  helperText={errors.surname?.message} 
  sx={{ textAlign: "right", direction: "rtl" }} 
  
  InputProps={{
    style: { fontSize: 20 , direction: "rtl" }
  }}
/>
<TextField 
  label={damage === 1 ? "اسم ام الشهيد" : "اسم ام الجريح"} 
  fullWidth 
  margin="normal"
  {...register("motherName", { 
    required: damage === 1 ? "اسم ام الشهيد مطلوب" : "اسم ام الجريح مطلوب",
    pattern: { 
      value: /^[\u0600-\u06FF]+$/, // Arabic letters only
      message: "يُسمح فقط بالحروف العربية بدون مسافات أو رموز" 
    } 
  })} 
  error={!!errors.motherName} 
  helperText={errors.motherName?.message} 
  sx={{ textAlign: "right", direction: "rtl" }} 
  
  InputProps={{
    style: { fontSize: 20 , direction: "rtl" }
  }}
/>
<TextField 
  label={damage === 1 ? "اسم (اب) ام الشهيد" : "اسم (اب) ام الجريح"} 
  fullWidth 
  margin="normal"
  {...register("MotherName2", { 
    required: damage === 1 ? "اسم (اب) ام الشهيد مطلوب" : "اسم (اب) ام الجريح مطلوب",
    pattern: { 
      value: /^[\u0600-\u06FF]+$/, // Arabic letters only
      message: "يُسمح فقط بالحروف العربية بدون مسافات أو رموز" 
    } 
  })} 
  error={!!errors.MotherName2} 
  helperText={errors.MotherName2?.message} 
  sx={{ textAlign: "right", direction: "rtl" }} 
 
  InputProps={{
    style: { fontSize: 20 , direction: "rtl" }
  }}
/>
<TextField 
  label={damage === 1 ? "اسم ( جد) ام الشهيد" : "اسم ( جد) ام الجريح"} 
  fullWidth 
  margin="normal"
  {...register("MotherName3", { 
    required: damage === 1 ? "اسم ( جد) ام الشهيد مطلوب" : "اسم ( جد) ام الجريح مطلوب",
    pattern: { 
      value: /^[\u0600-\u06FF]+$/, // Arabic letters only
      message: "يُسمح فقط بالحروف العربية بدون مسافات أو رموز" 
    } 
  })} 
  error={!!errors.MotherName3} 
  helperText={errors.MotherName3?.message} 
  sx={{ textAlign: "right", direction: "rtl" }} 
  
  InputProps={{
    style: { fontSize: 20 , direction: "rtl" }
  }}
/>
  {/* Dropdown Select Field */}
  <FormControl fullWidth margin="normal" error={!!errors.sex}>
        <InputLabel>اختر الجنس</InputLabel>
        <Controller
          name="sex"
          control={control}
          rules={{ required: "الرجاء اختيار الجنس" }}
          render={({ field }) => (
            <Select
              {...field}
              label={damage === 1 ? "جنس الشهيد" : "جنس المصاب"}
              sx={{ textAlign: "right", direction: "rtl" , fontSize: 20 , fontWeight: "bold" }}
              InputLabelProps={{ shrink: true , style: { fontSize: 20 , fontWeight: "bold" } }}
            >
              <MenuItem value="ذكر">ذكر</MenuItem>
              <MenuItem value="انثى">انثى</MenuItem>
            </Select>
          )}
        />
        {errors.sex && <Typography color="error">{errors.sex.message}</Typography>}
      </FormControl>
      <TextField
        label="تاريخ الميلاد"
        type="date"
        fullWidth
        margin="normal"
        {...register("birthdate", { required: "تاريخ الميلاد مطلوب" })}
        error={!!errors.birthdate}
        helperText={errors.birthdate?.message}
        sx={{ textAlign: "right", direction: "rtl" }}
    
        InputProps={{
          style: { fontSize: 20 , direction: "rtl" }
        }}
      />

<FormControl fullWidth margin="normal" error={!!errors.socialStatus}>
        <InputLabel>الحالة الاجتماعية</InputLabel>
        <Controller
          name="socialStatus"
          control={control}
          rules={{ required: "الرجاء اختيار الحالة الاجتماعية" }}
          render={({ field }) => (
            <Select
              {...field}
              label="الحالة الاجتماعية"
              sx={{ textAlign: "right", direction: "rtl" , fontSize: 20 , fontWeight: "bold" }}
            >
              <MenuItem value="اعزب/عزباء">اعزب/عزباء</MenuItem>
              <MenuItem value="متزوج/متزوجة">متزوج/متزوجة</MenuItem>
              <MenuItem value="مطلق/مطلقة">مطلق/مطلقة</MenuItem>
              <MenuItem value="ارمل/ارملة">ارمل/ارملة</MenuItem>
            </Select>
          )}
        />
        {errors.socialStatus && <Typography color="error">{errors.socialStatus.message}</Typography>}
      </FormControl>

       {/* Conditionally render the "عدد الزوجات" dropdown */}
       {socialStatus === "متزوج/متزوجة" && sex === "ذكر" && damage === 1 && (
        <FormControl fullWidth margin="normal" error={!!errors.numberOfWives}>
          <InputLabel>عدد الزوجات</InputLabel>
          <Controller
            name="numberOfWives"
            control={control}
            
            rules={{ required: "الرجاء اختيار عدد الزوجات" }}
            render={({ field }) => (
              <Select
                {...field}
                label="عدد الزوجات"
                sx={{ textAlign: "right", direction: "rtl" , fontSize: 20 , fontWeight: "bold" }}
              >
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="2">2</MenuItem>
                <MenuItem value="3">3</MenuItem>
                <MenuItem value="4">4</MenuItem>
              </Select>
            )}
          />
          {errors.numberOfWives && <Typography color="error">{errors.numberOfWives.message}</Typography>}
        </FormControl>
      )}
       <FormControl fullWidth margin="normal" error={!!errors.isParentAlive}>
        <InputLabel> {damage === 1 ? "هل والدي الشهيد او احدهما على قيد الحياة؟" : "هل والدي الجريح  او احدهما على قيد الحياة؟"}</InputLabel>
        <Controller
          name="isParentAlive"
          control={control}
          rules={{ required: "الرجاء اختيار هل والدي الشهيد/ الجريح او احدهما على قيد الحياة؟" }}
          render={({ field }) => (
            <Select
              {...field}
              label={damage === 1 ? "هل والدي الشهيد او احدهما على قيد الحياة؟" : "هل والدي الجريح او احدهما على قيد الحياة؟"}
              sx={{ textAlign: "right", direction: "rtl" , fontSize: 20 , fontWeight: "bold" }}
              InputLabelProps={{ shrink: true , style: { fontSize: 20 , fontWeight: "bold" } }}
            >
              <MenuItem value="1">نعم</MenuItem>
              <MenuItem value="0">لا</MenuItem>
            </Select>
          )}
        />
        {errors.isParentAlive && <Typography color="error">{errors.isParentAlive.message}</Typography>}
      </FormControl>
      <FormControl fullWidth margin="normal" error={!!errors.isMartyerStopped}>
        <InputLabel>{damage === 1 ? "هل تم ايقاف قرار الشهيد والمستحقات حاليا؟" : "هل تم ايقاف قرار الجريح والمستحقات حاليا؟"}</InputLabel>
        <Controller
          name="isMartyerStopped"
          control={control}
          rules={{ required: "الرجاء اختيار هل تم ايقاف القرار حاليا" }}
          render={({ field }) => (
            <Select
              {...field}
              label={damage === 1 ? "هل تم ايقاف قرار الشهيد والمستحقات حاليا؟" : "هل تم ايقاف قرار الجريح والمستحقات حاليا؟"}
              sx={{ textAlign: "right", direction: "rtl" , fontSize: 20 , fontWeight: "bold" }}
              InputLabelProps={{ shrink: true , style: { fontSize: 20 , fontWeight: "bold" } }}
            >
              <MenuItem value="1">نعم</MenuItem>
              <MenuItem value="0">لا</MenuItem>
            </Select>
          )}
        />
        {errors.isMartyerStopped && <Typography color="error">{errors.isMartyerStopped.message}</Typography>}
      </FormControl>
      {damage === 2 && (
       <TextField 
       label="نسبة الاصابة الاخيرة" 
       fullWidth 
       margin="normal"
       {...register("lastInjuryPercentage", { 
         required: "نسبة الاصابة الاخيرة مطلوبة", 
         pattern: {
           value: /^\d{1,3}$/, 
           message: "يجب أن يكون رقم الاصابة اخر 3 ارقماً فقط"
         },
         validate: value => 
           parseInt(value, 10) <= 100 || "يجب أن تكون النسبة أقل من أو تساوي 100"
       })} 
       error={!!errors.lastInjuryPercentage} 
       helperText={errors.lastInjuryPercentage?.message} 
       sx={{ textAlign: "right", direction: "rtl" }}
       InputProps={{
         style: { fontSize: 20, direction: "rtl" }
       }}
     />
      )}
      <Box sx={{ mt: 3, border: '1px solid #ccc', borderRadius: 2, p: 2 }}>
  <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
    الحقوق المستلمة
  </Typography>

  <FormControlLabel
    control={
      <Controller
        name="isLand"
        control={control}
        render={({ field }) => (
          <Checkbox
            {...field}
            checked={field.value === true || field.value === "1"}
            onChange={(e) => field.onChange(e.target.checked ? "1" : "0")}
          />
        )}
      />
    }
    label={damage === 1 ? "هل ذوي الشهيد مستلمين لقطعة ارض" : "هل  الجريح مستلم لقطعة ارض"}
  />

  <FormControlLabel
    control={
      <Controller
        name="isAppartment"
        control={control}
        render={({ field }) => (
          <Checkbox
            {...field}
            checked={field.value === true || field.value === "1"}
            onChange={(e) => field.onChange(e.target.checked ? "1" : "0")}
          />
        )}
      />
    }
    label={damage === 1 ? "هل ذوي الشهيد مستلمين وحدة سكنية" : "هل  الجريح مستلم وحدة سكنية"}
  />

  <FormControlLabel
    control={
      <Controller
        name="isCash1"
        control={control}
        render={({ field }) => (
          <Checkbox
            {...field}
            checked={field.value === true || field.value === "1"}
            onChange={(e) => field.onChange(e.target.checked ? "1" : "0")}
          />
        )}
      />
    }
    label={damage === 1 ? "هل ذوي الشهيد مستلمين لبدل نقدي" : "هل  الجريح مستلم لبدل نقدي"}
  />

  <FormControlLabel
    control={
      <Controller
        name="isSalary"
        control={control}
        render={({ field }) => (
          <Checkbox
            {...field}
            checked={field.value === true || field.value === "1"}
            onChange={(e) => field.onChange(e.target.checked ? "1" : "0")}
          />
        )}
      />
    }
    label={damage === 1 ? "هل ذوي الشهيد مستلمين لراتب تقاعدي" : "هل  الجريح مستلم لراتب تقاعدي"}
  />
</Box>
      <Grid2 container flexDirection="column"  spacing={2}>
        <label style={{ textAlign: "center", direction: "rtl" , fontSize: 25 , fontWeight: "bold" , marginBottom: 10 , marginTop: 10 }} htmlFor="province">{damage === 1 ? "عنوان السكن الحالي لعائلة الشهيد" : "عنوان السكن الحالي للجريح"}</label>
      <FormControl fullWidth margin="normal" error={!!errors.province}>
  <InputLabel>المحافظة (عنوان السكن الحالي)</InputLabel>
  <Controller
    name="province"
    control={control}
    rules={{ required: "الرجاء اختيار المحافظة" }}
    render={({ field }) => (
      <Select
        {...field}
        label="المحافظة (عنوان السكن الحالي)"
        sx={{ textAlign: "right", direction: "rtl", fontSize: 20, fontWeight: "bold" }}
      >
        <MenuItem value="بغداد">بغداد</MenuItem>
        <MenuItem value="البصرة">البصرة</MenuItem>
        <MenuItem value="نينوى">نينوى</MenuItem>
        <MenuItem value="كربلاء">كربلاء</MenuItem>
        <MenuItem value="النجف">النجف</MenuItem>
        <MenuItem value="الديوانية">الديوانية</MenuItem>
        <MenuItem value="الأنبار">الأنبار</MenuItem>
        <MenuItem value="ديالى">ديالى</MenuItem>
        <MenuItem value="بابل">بابل</MenuItem>
        <MenuItem value="واسط">واسط</MenuItem>
        <MenuItem value="ميسان">ميسان</MenuItem>
        <MenuItem value="ذي قار">ذي قار</MenuItem>
        <MenuItem value="المثنى">المثنى</MenuItem>
        <MenuItem value="صلاح الدين">صلاح الدين</MenuItem>
        <MenuItem value="كركوك">كركوك</MenuItem>
        <MenuItem value="دهوك">دهوك</MenuItem>
        <MenuItem value="أربيل">أربيل</MenuItem>
        <MenuItem value="السليمانية">السليمانية</MenuItem>
      </Select>
    )}
  />
  {errors.province && <Typography color="error">{errors.province.message}</Typography>}
</FormControl>
  <Grid2 item xs={3}>
    <TextField
      label="القضاء(عنوان السكن الحالي)"
      {...register("court", { required: "القضاء مطلوب" })}
      error={!!errors.court}
      helperText={errors.court?.message}
      fullWidth
      variant="outlined"
      sx={{ textAlign: "right", direction: "rtl"  }}
    
      InputProps={{
        style: { fontSize: 20 , direction: "rtl" }
      }}
    />
  </Grid2>
  <Grid2 item xs={3}>
    <TextField
      label="محلة(عنوان السكن الحالي)"
      {...register("muhalla", { required: "المحلة مطلوبة" })}
      error={!!errors.muhalla}
      helperText={errors.muhalla?.message}
      fullWidth
      variant="outlined"
      sx={{ textAlign: "right", direction: "rtl"  }}
    
      InputProps={{
        style: { fontSize: 20 , direction: "rtl" }
      }}
    />
  </Grid2>
  <Grid2 item xs={3}>
    <TextField
      label="زقاق(عنوان السكن الحالي)"
      {...register("street", { required: "الزقاق مطلوب" })}
      error={!!errors.street}
      helperText={errors.street?.message}
      fullWidth
      variant="outlined"
      sx={{ textAlign: "right", direction: "rtl"  }}
      
      InputProps={{
        style: { fontSize: 20 , direction: "rtl" }
      }}
    />
  </Grid2>

  <Grid2 item xs={3}>
    <TextField
      label="دار(عنوان السكن الحالي)"
      {...register("dar", { required: "الدار مطلوبة" })}
      error={!!errors.dar}
      helperText={errors.dar?.message}
      fullWidth
      variant="outlined"
      sx={{ textAlign: "right", direction: "rtl"  }}
     
      InputProps={{
        style: { fontSize: 20 , direction: "rtl" }
      }}
    />
  </Grid2>
  <br></br>
</Grid2>
{/* <FormControlLabel
  control={
    <Checkbox {...register("isPreviousAddressSame")} sx={{ direction: "rtl" }} />
  }
  label="هل يوجد محل سكن سابق؟"
  labelPlacement="start" // Moves label to the right of the checkbox
  sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }} // Aligns to right
/> */}


    <Grid2 container flexDirection="column" spacing={2}>
    <label style={{ textAlign: "center", direction: "rtl" , fontSize: 25 , fontWeight: "bold" , marginBottom: 10 , marginTop: 10 }} htmlFor="province">{damage === 1 ? "عنوان سكن عائلة الشهيد سابقا" : "عنوان سكن عائلة الجريح سابقا"}</label>
       <FormControl fullWidth margin="normal" error={!!errors.previousProvince}>
  <InputLabel>المحافظة (عنوان السكن السابق)</InputLabel>
  <Controller
    name="previousProvince"
    control={control}
    rules={{ required: "الرجاء اختيار المحافظة" }}
    render={({ field }) => (
      <Select
        {...field}
        label="المحافظة (عنوان السكن السابق)"
        sx={{ textAlign: "right", direction: "rtl", fontSize: 20, fontWeight: "bold" }}
      >
        <MenuItem value="بغداد">بغداد</MenuItem>
        <MenuItem value="البصرة">البصرة</MenuItem>
        <MenuItem value="نينوى">نينوى</MenuItem>
        <MenuItem value="كربلاء">كربلاء</MenuItem>
        <MenuItem value="النجف">النجف</MenuItem>
        <MenuItem value="الديوانية">الديوانية</MenuItem>
        <MenuItem value="الأنبار">الأنبار</MenuItem>
        <MenuItem value="ديالى">ديالى</MenuItem>
        <MenuItem value="بابل">بابل</MenuItem>
        <MenuItem value="واسط">واسط</MenuItem>
        <MenuItem value="ميسان">ميسان</MenuItem>
        <MenuItem value="ذي قار">ذي قار</MenuItem>
        <MenuItem value="المثنى">المثنى</MenuItem>
        <MenuItem value="صلاح الدين">صلاح الدين</MenuItem>
        <MenuItem value="كركوك">كركوك</MenuItem>
        <MenuItem value="دهوك">دهوك</MenuItem>
        <MenuItem value="أربيل">أربيل</MenuItem>
        <MenuItem value="السليمانية">السليمانية</MenuItem>
      </Select>
    )}
  />
  {errors.previousProvince && <Typography color="error">{errors.previousProvince.message}</Typography>}
</FormControl>
        <Grid2 direction="rtl"  item xs={3}>
          <TextField
            label="القضاء(عنوان السكن السابق)"
            {...register("previousCourt", { required: "القضاء السابق مطلوب" })}
            error={!!errors.previousCourt}
            helperText={errors.previousCourt?.message}
            fullWidth
            variant="outlined"
            sx={{ textAlign: "right", direction: "rtl"  }}
           
            InputProps={{
              style: { fontSize: 20 , direction: "rtl" }
            }}
          />
        </Grid2>
        <Grid2 item xs={3}>
          <TextField
            label="(عنوان السكن السابق)محلة"
            {...register("previousMuhalla", { required: "المنطقة المدنية السابقة مطلوبة" })}
            error={!!errors.previousMuhalla}
            helperText={errors.previousMuhalla?.message}
            fullWidth
            variant="outlined"
            sx={{ textAlign: "right", direction: "rtl"  }}
           
            InputProps={{
              style: { fontSize: 20 , direction: "rtl" }
            }}
          />
        </Grid2>
        <Grid2 item xs={3}>
          <TextField
            label="زقاق(عنوان السكن السابق)"
            {...register("previousStreet", { required: "الزقاق السابقة مطلوبة" })}
            error={!!errors.previousStreet}
            helperText={errors.previousStreet?.message}
            fullWidth
            variant="outlined"
            sx={{ textAlign: "right", direction: "rtl"  }}
           
            InputProps={{
              style: { fontSize: 20 , direction: "rtl" }
            }}
          />
        </Grid2>
        <Grid2 item xs={3}>
          <TextField
            label="دار(عنوان السكن السابق)"
            {...register("previousDar", { required: "الدار السابقة مطلوبة" })}
            error={!!errors.previousDar}
            helperText={errors.previousDar?.message}
            fullWidth
            variant="outlined"
            sx={{ textAlign: "right", direction: "rtl"  }}
           
            InputProps={{
              style: { fontSize: 20 , direction: "rtl" }
            }}
          />
        </Grid2>
      </Grid2>
  

      <FormControl fullWidth margin="normal" error={!!errors.profession}>
        <InputLabel>المهنة</InputLabel>
        <Controller
          name="profession"
          control={control}
          rules={{ required: "الرجاء اختيار المهنة" }}
          render={({ field }) => (
            <Select
              {...field}
              label="المهنة"
              sx={{ textAlign: "right", direction: "rtl" }}
            >
              <MenuItem value="كاسب">كاسب</MenuItem>
              <MenuItem value="موظف">موظف</MenuItem>
              <MenuItem value="عسكري دفاع">عسكري دفاع</MenuItem>
              <MenuItem value="عسكري داخلية">عسكري داخلية</MenuItem>
              <MenuItem value="عسكري امن وطني">عسكري امن وطني</MenuItem>
              <MenuItem value="عسكري جهاز مكافحة الارهاب">عسكري جهاز مكافحة الارهاب</MenuItem>
              <MenuItem value="عسكري جهاز المخابرات الوطني">عسكري جهاز المخابرات الوطني</MenuItem>
            </Select>
          )}
        />
        {errors.profession && <Typography color="error">{errors.profession.message}</Typography>}
      </FormControl>

       {/* Conditionally render the "عدد الزوجات" dropdown */}
       {profession === "موظف" && (
       <TextField 
       label="الوزارة" 
       fullWidth 
       margin="normal"
       {...register("ministry", { 
         required: "الوزارة مطلوبة",
         pattern: { 
          value: /^[\u0600-\u06FF\s]+$/, // Arabic letters with spaces allowed
      message: "يُسمح فقط بالحروف العربية والمسافات" 
         } 
       })} 
       error={!!errors.ministry} 
       helperText={errors.ministry?.message} 
       sx={{ textAlign: "right", direction: "rtl" }} 
      
       InputProps={{
         style: { fontSize: 20 , direction: "rtl" }
       }}
     />
      )}

<TextField 
  label="مكان الحادث" 
  fullWidth 
  margin="normal"
  {...register("placeOfIncident", { 
    required: "مكان الحادث مطلوب",
    pattern: { 
      value: /^[\u0600-\u06FF\s]+$/, // Arabic letters with spaces allowed
      message: "يُسمح فقط بالحروف العربية والمسافات" 
    } 
  })} 
  error={!!errors.placeOfIncident} 
  helperText={errors.placeOfIncident?.message} 
  sx={{ textAlign: "right", direction: "rtl" }} 
  
  InputProps={{
    style: { fontSize: 20 , direction: "rtl" }
  }}
/>

<TextField
        label="تاريخ الحادث"
        type="date"
        fullWidth
        margin="normal"
        {...register("incidentDate", { required: "تاريخ الحادث مطلوب" })}
        error={!!errors.incidentDate}
        helperText={errors.incidentDate?.message}
        sx={{ textAlign: "right", direction: "rtl" }}
      
        InputProps={{
          style: { fontSize: 20 , direction: "rtl" }
        }}
      />

      <TextField 
        label="1رقم الهاتف" 
        fullWidth 
        margin="normal"
        {...register("phone1", { 
          required: "رقم الهاتف مطلوب", 
          pattern: { 
            value: /^\d{11}$/, 
            message: "رقم الهاتف يجب أن يكون 11 رقماً فقط" 
          } 
        })} 
        error={!!errors.phone1} 
        helperText={errors.phone1?.message} 
        sx={{ textAlign: "right", direction: "rtl" }}
       
        InputProps={{
          style: { fontSize: 20 , direction: "rtl" }
        }}
      />
      <TextField 
        label="2رقم الهاتف" 
        fullWidth 
        margin="normal"
        {...register("phone2", { 
          required: "رقم الهاتف مطلوب", 
          pattern: { 
            value: /^\d{11}$/, 
            message: "رقم الهاتف يجب أن يكون 11 رقماً فقط" 
          } 
        })} 
        error={!!errors.phone2} 
        helperText={errors.phone2?.message} 
        sx={{ textAlign: "right", direction: "rtl" }}
        
        InputProps={{
          style: { fontSize: 20 , direction: "rtl" }
        }}
      />
     <TextField 
  label="3رقم الهاتف" 
  fullWidth 
  margin="normal"
  {...register("phone3", { 
    required: "رقم الهاتف مطلوب", 
    pattern: { 
      value: /^\d{11}$/, 
      message: "رقم الهاتف يجب أن يكون 11 رقماً فقط" 
    } 
  })} 
  error={!!errors.phone3} 
  helperText={errors.phone3?.message} 
  sx={{ textAlign: "right", direction: "rtl" }}
  InputProps={{
    style: { fontSize: 20 , direction: "rtl" }
  }}
/>

<TextField 
  label="الملاحظات" 
  fullWidth 
  margin="normal"
  multiline
  rows={4} // You can change this to 6 or more if needed
  {...register("notes")} 
  error={!!errors.notes} 
  helperText={errors.notes?.message} 
  sx={{ textAlign: "right", direction: "rtl" }}
  InputProps={{
    style: { fontSize: 20, direction: "rtl" }
  }}
/>
{damage === 1 && (
  <Box sx={{ mt: 3, border: '1px solid #ccc', borderRadius: 2, p: 2 }}>
<TextField 
  label="اسم مقدم الاستمارة" 
  fullWidth 
  margin="normal"
  {...register("appName", { 
    required: "اسم مقدم الاستمارة مطلوب",
    pattern: { 
      value: /^[\u0600-\u06FF\s]+$/, // Arabic letters with spaces allowed
      message: "يُسمح فقط بالحروف العربية والمسافات" 
    } 
  })} 
  error={!!errors.appName} 
  helperText={errors.appName?.message} 
  sx={{ textAlign: "right", direction: "rtl" }} 
  
  InputProps={{
    style: { fontSize: 20 , direction: "rtl" }
  }}
/>

<FormControl fullWidth margin="normal" error={!!errors.appLink}>
  <InputLabel>صلة مقدم الاستمارة بالشهيد</InputLabel>
  <Controller
    name="appLink"
    control={control}
    rules={{ required: "صلة مقدم الاستمارة بالشهيد مطلوبة" }}
    render={({ field }) => (
      <Select
        {...field}
        value={field.value || ""}
        onChange={(e) => field.onChange(e.target.value)}
        label="صلة مقدم الاستمارة بالشهيد"
        sx={{ textAlign: "right", direction: "rtl", fontSize: 20, fontWeight: "bold" }}
      >
        <MenuItem value="والدي">اب / ام الشهيد</MenuItem>
        <MenuItem value="اخوة">اخ / اخت الشهيد</MenuItem>
        <MenuItem value="زوج">زوج / زوجة الشهيد</MenuItem>
        <MenuItem value="ابناء">ابن / بنت الشهيد</MenuItem>
      </Select>
    )}
  />
  {errors.appLink && <Typography color="error">{errors.appLink.message}</Typography>}
</FormControl>
</Box>
)}


      <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
        { damage === 1 ? "الانتقال الى الصفحة التالية" : "انتقال الى الصفحة التالية" }
      </Button>
    </Box>
    </ThemeProvider>
    </CacheProvider>
  );
};

export default WebForm;
